import { render, staticRenderFns } from "./IrisChipsContainer.vue?vue&type=template&id=4f630445&"
import script from "./IrisChipsContainer.vue?vue&type=script&lang=ts&"
export * from "./IrisChipsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./IrisChipsContainer.vue?vue&type=style&index=0&id=4f630445&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports